import { render, staticRenderFns } from "./ProvidersApprovalTray.vue?vue&type=template&id=34835d96&scoped=true"
import script from "./ProvidersApprovalTray.vue?vue&type=script&lang=js"
export * from "./ProvidersApprovalTray.vue?vue&type=script&lang=js"
import style0 from "./ProvidersApprovalTray.vue?vue&type=style&index=0&id=34835d96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34835d96",
  null
  
)

export default component.exports